import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import './FrontHeader.css';

const FrontHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/available-jobs', label: 'Available Jobs' },
    { path: '/service-providers', label: 'Find Service Providers' },
    { path: '/services', label: 'Services' },
    { path: '/how-it-works', label: 'How it Works' }
  ];

  const handleLogin = () => navigate('/login');
  const handleRegister = () => navigate('/register');
  const handleLogoClick = () => navigate('/');

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className={`front-header-navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="front-header-nav-container">
        <div className="front-header-logo" onClick={handleLogoClick}>
          Sea<span>Zex</span>
        </div>

        <button 
          className="front-header-mobile-menu-btn" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Menu"
        >
          <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>

        <div className={`front-header-nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          {navItems.map((item) => (
            <a
              key={item.path}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate(item.path);
              }}
              className={isActive(item.path) ? 'active' : ''}
            >
              {item.label}
            </a>
          ))}
          
          <div className="front-header-nav-auth-mobile">
            <button className="front-header-btn-secondary" onClick={handleLogin}>
              Log In
            </button>
            <button className="front-header-btn-primary" onClick={handleRegister}>
              Register for Beta
            </button>
          </div>
        </div>

        <div className="front-header-nav-auth">
          <button
            className="front-header-theme-btn"
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
            aria-label="Toggle theme"
          >
            <i className={`fa-solid ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`}></i>
          </button>
          <button className="front-header-btn-secondary" onClick={handleLogin}>
            Log In
          </button>
          <button className="front-header-btn-primary" onClick={handleRegister}>
            Register for Beta
          </button>
        </div>
      </div>
    </nav>
  );
};

export default FrontHeader;